import React from "react"
import { useTranslate } from "hooks/translate"
import Heading from "app/components/Heading"
import Copyright from "app/components/Copyright"
import { useAppflow } from "app/hooks/useAppFlow"
import LayoutDefault from "../Default/index"
import {
  StyledContainer,
  StyledLayout,
  StyledLayoutAside,
  StyledLayoutAsideBody,
  StyledLayoutMain,
  StyledLayoutSection,
  StyledFooter,
  StyledDivider,
  StyledFooterContent,
  StyledHeader,
  StyledLogoWrapper,
  StyledLogo,
  StyledKBCLogoWrapper,
  StyledKBCLogo,
  StyledCBCLogo,
  StyledLink
} from "./style"

const LayoutAppflow: React.FC = ({ children }) => {
  const { t } = useTranslate()
  const { clientType, carType, product, bank } = useAppflow()

  if (!product) {
    return <LayoutDefault children={children} />
  }

  return (
    <>
      <StyledHeader>
        <StyledLogoWrapper>
          <StyledLink to="/">
            <StyledLogo />
          </StyledLink>
        </StyledLogoWrapper>
      </StyledHeader>
      <StyledLayout>
        <StyledLayoutAside>
          <StyledLayoutAsideBody>
            <div>
              <Heading>
                {t(`form.aside.${clientType}.${carType}.${product}.heading`)}
              </Heading>
              <p>
                {t(`form.aside.${clientType}.${carType}.${product}.description`, {
                  br: <br />,
                  bank: bank || "KBC"
                })}
              </p>
            </div>
            <StyledKBCLogoWrapper>
              {bank === "KBC" && <StyledKBCLogo />}
              {bank === "CBC" && <StyledCBCLogo />}
            </StyledKBCLogoWrapper>
          </StyledLayoutAsideBody>
        </StyledLayoutAside>
        <StyledLayoutMain>
          <StyledLayoutSection>
            <StyledContainer>{children}</StyledContainer>
          </StyledLayoutSection>
        </StyledLayoutMain>
      </StyledLayout>
      <StyledFooter>
        <StyledDivider />
        <StyledFooterContent>
          <div>
            <Copyright>
              {t("system.legal.copyright", { year: new Date().getFullYear() })}
            </Copyright>
          </div>
        </StyledFooterContent>
      </StyledFooter>
    </>
  )
}

export default LayoutAppflow
